module.exports = "/fonts/Montserrat-BoldItalic.ttf?781190aecb862fffe858d42b124658cc";